import './PublicSite.css';

export default function SuccessStories() {
  return (
    <div className="page success-stories-page">
      <section className="page-hero">
        <div className="container">
          <h1>Success Stories</h1>
          <p className="lead">Real animals. Real transformations. Real hope.</p>
        </div>
      </section>

      <section className="content-section">
        <div className="container">
          <div className="story-grid">
            <div className="story-card featured">
              <div className="story-image" style={{
                backgroundImage: `url('https://static.prod-images.emergentagent.com/jobs/233c16bd-c6cb-4f72-9afd-f013a1c1f7cc/images/404a030fd07d8c7beb5c0d526e97a018960191fe82b1ef7ef2995af856914d60.png')`
              }}></div>
              <div className="story-content">
                <h2>The Dog Who Mauled Me</h2>
                <p className="story-meta">Case Study | High-Risk Rehabilitation</p>
                <p>
                  A dog attacked and mauled me during an initial assessment. The owner was given one option by authorities: euthanasia. There was "no other choice."
                </p>
                <p>
                  We made a different choice. I moved the owner, his wife, and the dog onto our sanctuary property. Together, we trained the dog through love, patience, and understanding. Today, that dog is thriving. <strong>We became its life force.</strong>
                </p>
                <p className="story-outcome">
                  <strong>Outcome:</strong> Dog successfully integrated. No further incidents. Owner trained in rehabilitation techniques. Life saved.
                </p>
              </div>
            </div>

            <div className="story-card">
              <h3>BFF Rescue Network Partnership</h3>
              <p className="story-meta">California | 5-Month Collaboration</p>
              <p>
                BFF Rescue Network (California) contacted us with urgent placements: 12 dogs labeled "problematic" and facing euthanasia deadlines.
              </p>
              <p>
                We took them all. Within 5 months:
              </p>
              <ul>
                <li><strong>12 dogs rescued</strong> from euthanasia</li>
                <li><strong>8 successfully rehomed</strong> to loving families</li>
                <li><strong>4 chose to stay</strong> at the sanctuary (thriving, integrated)</li>
                <li><strong>100% transformation</strong> from "problematic" to "perfect"</li>
              </ul>
              <p className="story-outcome">
                <strong>Outcome:</strong> All 12 dogs alive and thriving. BFF Rescue Network now requests we take 60 more.
              </p>
            </div>

            <div className="story-card">
              <h3>The Animals Who Won't Leave</h3>
              <p className="story-meta">Ongoing | Retention Phenomenon</p>
              <p>
                Our sanctuary has an unusual "problem": <strong>60% of rehabilitated animals refuse to leave</strong> even after successful adoption.
              </p>
              <p>
                Adopters come to pick up their new dog or cat. The animal looks at them, then looks back at the sanctuary, and... stays. Adopted animals return from their new homes. Neighbors' pets wander over and choose to live here.
              </p>
              <p>
                Why? Because the environment is so healing, so safe, so full of love that they don't <em>want</em> to leave.
              </p>
              <p className="story-outcome">
                <strong>This is the ultimate success metric:</strong> Animals who have the freedom to leave... choose to stay.
              </p>
            </div>

            <div className="story-card">
              <h3>Human Rehabilitation Success</h3>
              <p className="story-meta">Anonymous | Off-Grid Transition</p>
              <p>
                A family facing homelessness and health crises came to the sanctuary seeking help. We provided:
              </p>
              <ul>
                <li>Off-grid living education (water systems, solar power, food production)</li>
                <li>Plant-based healing protocols for chronic illness</li>
                <li>Animal care training (providing purpose and income skills)</li>
                <li>Community integration (becoming part of the sanctuary family)</li>
              </ul>
              <p className="story-outcome">
                <strong>Outcome:</strong> Family now operates their own off-grid homestead. Health improved. Self-sufficient. Still connected to sanctuary community.
              </p>
            </div>
          </div>

          <div className="testimonial-section">
            <h2>In Their Own Words</h2>
            <div className="testimonial">
              <p className="testimonial-text">
                "Mary didn't just save my dog—she saved my family. When everyone else said 'put him down,' she said 'let's heal him together.' And we did."
              </p>
              <p className="testimonial-author">— Dog Owner, Oregon</p>
            </div>
            <div className="testimonial">
              <p className="testimonial-text">
                "I've worked in animal rescue for 15 years. I've never seen a 100% success rate. But Mary has it. Her method works because it's built on love, not control."
              </p>
              <p className="testimonial-author">— Rescue Network Partner, California</p>
            </div>
          </div>
        </div>
      </section>

      <section className="stats-section">
        <div className="container">
          <h2>By The Numbers</h2>
          <div className="stat-grid">
            <div className="stat">
              <div className="stat-number">100%</div>
              <div className="stat-label">Integration Success Rate</div>
            </div>
            <div className="stat">
              <div className="stat-number">60%</div>
              <div className="stat-label">Choose to Stay Forever</div>
            </div>
            <div className="stat">
              <div className="stat-number">12</div>
              <div className="stat-label">BFF Rescue Network Dogs Saved</div>
            </div>
            <div className="stat">
              <div className="stat-number">0</div>
              <div className="stat-label">Animals Euthanized</div>
            </div>
          </div>
        </div>
      </section>

      <section className="cta-section">
        <div className="container">
          <h2>Every Animal Has a Story</h2>
          <p>And every story deserves a chance at a happy ending. Help us write more success stories.</p>
          <a href="/how-to-help" className="btn btn-primary btn-large">Support Our Work</a>
        </div>
      </section>
    </div>
  );
}